
import {Injectable} from '@angular/core';
import {apiUrl} from '../../config/api.config';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class RestApiMarketingService {
  baseUrl = (apiUrl);

  constructor(private http: Http) {
  }


  /**
   * Register Landlord and Get Custom token from Rest API
   * @param email
   * @param password
   * @param schoolname
   * @param contact
   * @returns {Observable<any>}
   */
  sendInviteToLandlord(email, message): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const body = ({
      email: email,
      message: message
    });

    console.log('Body: ', body, options);
    return this.http
      .post(this.baseUrl + 'sendEmailToInviteLandlord', body, options)
      .map(response => response.json());
  }

}








// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/rest-api/marketing.service.ts